
import mutations from './mutations'
import actions from './action'
import getters from './getters'



const state = {
	cartInfo:[],
	selDay:null,
	cardInfo:null,
	stepInfo:{
		choosedAddress:null,
	},
	choosedAddress: null, //选择地址
	addressIndex: null, //选择地址的索引值
	unSave:{
		cartInfo:false,
		choosedAddress:null,
		selDay:null,
		cardInfo:null,
		loading:false
		
	},
	lrpSku:[],
	lrptConfig:null,
	edit:false,
	isBuy:-1 //购买AB 资格
}

export default {
	state,
 	getters,
  	actions,
  	mutations
}